import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment";

export default {
  state: () => ({
    selectedMilitaryUnit: {
      name: null,
      saleChannelIds: [],
    },
  }),

  mutations: {
    setSelectedMilitaryUnit(state, selectedMilitaryUnit) {
      Vue.set(state, "selectedMilitaryUnit", selectedMilitaryUnit);
    },
  },
  actions: {
    //TODO: load, update, create
    createMilitaryUnit: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/military-units/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadMilitaryUnits: (context) => {
      //TODO: Loader start
      return axios
        .get(context.getters.getMcServiceUrl + "/military-units/entity", {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadMilitaryUnit: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/military-units/entity/" + request.id).then((response) => {
        context.commit("setSelectedMilitaryUnit", response.data);
        return response.data;
      });
    },
    loadSelectedMilitaryUnitHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/military-units/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteMilitaryUnit: (context, militaryUnit) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/military-units/entity/" + militaryUnit.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          militaryUnit.intents = intents;
          militaryUnit.intentId = response.data.id;
          return militaryUnit;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishMilitaryUnit: (context, militaryUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/military-units/publish/" + militaryUnit.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectMilitaryUnit: (context, militaryUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/military-units/reject/" + militaryUnit.intentId).then((response) => {
        if (militaryUnit.intents[0].type === "DELETE_ANNOUNCEMENT") {
          militaryUnit.intents = null;
          militaryUnit.intentId = 0;
        } else if (militaryUnit.intents[0].type === "CREATE_ANNOUNCEMENT") {
          militaryUnit.intents[0].status = "DRAFT";
        } else if (militaryUnit.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          militaryUnit.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalMilitaryUnit: (context, militaryUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/military-units/sendToApproval/" + militaryUnit.intentId).then((response) => {
        if (militaryUnit.intents[0].type === "CREATE_ANNOUNCEMENT") {
          militaryUnit.intents[0].status = "WAITING_APPROVAL";
        } else if (militaryUnit.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          militaryUnit.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallMilitaryUnit: (context, militaryUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/military-units/recall/" + militaryUnit.intentId).then((response) => {
        helper.recallOrRejectEntity(militaryUnit, "MilitaryUnit");
        return response.data;
      });
    },

    cancelMilitaryUnit: (context, militaryUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/military-units/cancel/" + militaryUnit.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedMilitaryUnit: (state) => {
      return state.selectedMilitaryUnit;
    },
  },
};
